import React from "react";
import { Container, Row, Col, Card, CardHeader, CardTitle } from "reactstrap";
import Footer from "../../../views/Common/Footer";
import ForgotPassword from "./ForgotPassword";
import ForgotVerify from "./ForgotVerify";
import ErrorBlock from "../../../components/ErrorBlock/ErrorBlock";
import SuccessBlock from "../../../components/SuccessBlock/SuccessBlock";
import InfoArea from "../../../components/InfoArea/InfoArea";

import { forgotPassword, forgotPasswordVerify } from "../../../datautils/actions/authActions";
import { resetResponseValues } from "../../../datautils/actions/responseHandlerActions";
import HomeHeader from "../../../components/Headers/HomeHeader";
import { isUserLoggedIn } from "../../../utils/helpers/HelperFunctions";
import { connect } from "react-redux";
import { SUPPLIER_BASE, LOGIN } from "../../../utils/constants/clientUrls";
import { defaultParams } from "../../../utils/constants/";

import ico1 from "../../../assets/img/laptop2@3x.png";
import ico2 from "../../../assets/img/screen3@3x.png";
import ico3 from "../../../assets/img/speaker2@3x.png";
import ico4 from "../../../assets/img/coin@3x.png";

class ForgotPasswordBase extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      step: 1,
      maxStep: 2,
      mobile: "",
      password: "",
      otp: "",
      mobileState: "",
      passwordState: "",
      otpState: "",
      isError: false,
      showSendOtpOption: false,
      otpVerified: false,
    };
  }
  componentDidMount() {
    this.props.resetResponseValues();
    if (isUserLoggedIn()) {
      this.props.history.push(SUPPLIER_BASE);
    }
  }
  nextStep = () => {
    let { step, maxStep } = this.state;
    step = step > maxStep ? maxStep : step;
    this.setState({
      step: step + 1,
    });
  };

  prevStep = () => {
    let { step } = this.state;
    step = step < 1 ? 1 : step;
    this.setState({
      step: step - 1,
    });
  };

  handleBack = () => {
    this.props.resetResponseValues();
    this.setState({
      step: 1,
    });
  };

  handleChange = (input) => (event) => {
    if (input === "mobile") {
      let numberRex = new RegExp("^[0-9]+$");
      let mobile = this.state.mobile;
      let mobileState = this.state.mobileState;
      mobile = event.target.value;
      if (numberRex.test(mobile) && mobile.length === 10) {
        mobileState = "is-valid";
      } else {
        mobileState = "is-invalid";
      }
      this.setState({ mobile, mobileState });
    } else if (input === "password") {
      let password = this.state.password;
      let passwordState = this.state.password;
      password = event.target.value;
      if (password.length > 5) {
        passwordState = "is-valid";
      } else {
        passwordState = "is-invalid";
      }
      this.setState({ password, passwordState });
    } else if (input === "otp") {
      let otp = this.state.otp;
      let otpState = this.state.otp;
      otp = event.target.value;
      if (otp.length === 4) {
        otpState = "is-valid";
      } else {
        otpState = "is-invalid";
      }
      this.setState({ otp, otpState });
    } else {
      this.setState({ [input]: event.target.value });
    }
  };

  onStop = () => {
    this.setState({ showSendOtpOption: true });
  };

  saveAndContinue = (e) => {
    const reqData = {
      userType: "SUPPLIER",
      mobileCountryCode: "+91",
      mobileNumber: this.state.mobile,
      ...defaultParams(),
    };
    this.props.forgotPassword(reqData);
    this.setState({ showSendOtpOption: false, otpVerified: false });
  };

  sendOTP = (e) => {
    e.preventDefault();

    const reqData = {
      userType: "SUPPLIER",
      mobileCountryCode: "+91",
      mobileNumber: this.state.mobile,
      newPassword: this.state.password,
      verificationCode: this.state.otp,
      ...defaultParams(),
    };
    this.props.forgotPasswordVerify(reqData);
    this.setState({ otpVerified: true });
  };

  componentDidUpdate(prevProps) {
    if (this.props.responseVal.status === "success" && this.state.step === 1) {
      this.nextStep();
    }

    if (this.props.responseVal.status === "success" && this.state.step === 2 && this.state.otpVerified) {
      this.props.history.push(LOGIN);
    }

    if (this.props.userId > 1) {
      this.props.history.push(SUPPLIER_BASE);
    }
  }

  render() {
    const { step, mobile, password, otp, mobileState, passwordState, otpState } = this.state;
    const values = { mobile, password, otp };
    const { responseVal } = this.props;

    const isEnabled = mobileState === "is-valid";

    const isEnabledReg = mobileState === "is-valid" && passwordState === "is-valid" && otpState === "is-valid";

    return (
      <div>
        <HomeHeader {...this.props} />
        <div className="full-page--content">
          <div className="register-page">
            <Container>
              <Row className="justify-content-center">
                <Col lg={8} md={8} xs={12}>
                  <h1>Become a seller and sell your products on Slickpals</h1>
                  <Row>
                    <Col sm={6}>
                      <InfoArea
                        img={ico1}
                        icon="now-ui-icons users_circle-08"
                        iconColor="neutral"
                        title="Sign Up"
                        titleColor="info"
                        description="After signup complete your KYC"
                      />
                    </Col>
                    <Col>
                      {" "}
                      <InfoArea
                        img={ico2}
                        icon="now-ui-icons shopping_tag-content"
                        iconColor="neutral"
                        title="List your products"
                        titleColor="info"
                        description="List your products on the plaltform"
                      />
                    </Col>

                    <Col sm={6}>
                      {" "}
                      <InfoArea
                        img={ico3}
                        icon="now-ui-icons objects_spaceship"
                        iconColor="neutral"
                        title="Build your market"
                        titleColor="info"
                        description="Grow you business with us"
                      />
                    </Col>

                    <Col sm={6}>
                      {" "}
                      <InfoArea
                        img={ico4}
                        icon="now-ui-icons business_money-coins"
                        iconColor="neutral"
                        title="Sell your products"
                        titleColor="info"
                        description="Increase your revenue"
                      />
                    </Col>
                  </Row>
                </Col>
                <Col lg={4} md={8} xs={12}>
                  <Card className="card-signup">
                    {(() => {
                      switch (step) {
                        case 1:
                          return (
                            <>
                              <CardHeader className="text-center">
                                <CardTitle tag="h4">Forgot Password</CardTitle>

                                {responseVal.status === "failure" ? (
                                  <ErrorBlock errors={responseVal.errors} position="alert-relative" />
                                ) : null}

                                {responseVal.status === "success" ? (
                                  <SuccessBlock msg={responseVal.data} position="alert-relative" />
                                ) : null}
                              </CardHeader>
                              <ForgotPassword
                                nextStep={this.nextStep}
                                values={values}
                                handleChange={this.handleChange}
                                saveAndContinue={this.saveAndContinue}
                                isEnabled={isEnabled}
                                mobileState={mobileState}
                              />
                            </>
                          );
                        case 2:
                          return (
                            <>
                              <CardHeader className="text-center">
                                <CardTitle tag="h4">Update Password</CardTitle>
                              </CardHeader>
                              {responseVal.status === "failure" ? (
                                <ErrorBlock errors={responseVal.errors} position="alert-relative" />
                              ) : null}

                              {responseVal.status === "success" ? (
                                <SuccessBlock msg={responseVal.data} position="alert-relative" />
                              ) : null}
                              <ForgotVerify
                                nextStep={this.nextStep}
                                prevStep={this.prevStep}
                                handleChange={this.handleChange}
                                values={values}
                                sendOTP={this.sendOTP}
                                passwordState={passwordState}
                                otpState={otpState}
                                isEnabled={isEnabledReg}
                                handleBack={this.handleBack}
                                onStop={this.onStop}
                                saveAndContinue={this.saveAndContinue}
                                showSendOtpOption={this.state.showSendOtpOption}
                              />
                            </>
                          );
                        default:
                          return null;
                      }
                    })()}
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.ui.isLoading,
    userId: state.auth.userId,
    responseVal: state.resHandlerVal,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    forgotPassword: (reqData) => dispatch(forgotPassword(reqData)),
    forgotPasswordVerify: (reqData) => dispatch(forgotPasswordVerify(reqData)),
    resetResponseValues: () => dispatch(resetResponseValues()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(ForgotPasswordBase);
